// extracted by mini-css-extract-plugin
module.exports = {"json":"ActionLogDetailsModal_json__3ccOJ"};